import axios from 'axios'

import { oldVersion } from '@/gql/check-version-link'

export const alert = (message: any) => {
  axios.post('/api/alerts', {
    message,
    version: oldVersion,
    userAgent: window.navigator.userAgent,
  })
}
